module.exports = __webpack_public_path__ + "img/login-bg.7d205003.jpg";